// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8c92f9f9","88":"af4e8c2a","125":"baf40d1a","232":"58262d68","310":"636941ca","942":"4873b4b3"}[chunkId] + ".chunk.js";
};